//U01TX0FVVEgyMDIwMDMxMDIzNTUzOTEwOTUzMzE=
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import axios from 'axios';
import { useStore } from '../../contexts/MapContext';
import FiveInfo from '../FiveInfo';
import * as S from './style';

const search = async query => {
  const { data } = await axios.get('https://finding-mask.herokuapp.com/', {
    params: {
      query
    }
  });
  return data;
};

const getAddress = async keyword => {
  const { data } = await axios.get(
    'https://www.juso.go.kr/addrlink/addrLinkApiJsonp.do',
    {
      params: {
        confmKey: 'U01TX0FVVEgyMDIwMDMxMDIzNTUzOTEwOTUzMzE=',
        resultType: 'json',
        countPerPage: 5,
        keyword
      }
    }
  );
  const addresses = JSON.parse(data.slice(1, -1)).results.juso;
  return addresses;
};
const Modal = observer(() => {
  const { setAddress, setLocation, setIsLoading } = useStore();
  const [addressList, setAddressList] = useState([]);
  const [keyword, setKeyword] = useState('');
  const handleKeywordChange = e => {
    setKeyword(e.target.value);
  };
  const temp = async keyword => {
    const address = await getAddress(keyword);
    setAddressList(address);
  };

  const handleResultClick = async address => {
    setIsLoading(true);
    const data = await search(address.roadAddrPart1);
    const { x, y } = data;
    setAddress(data.roadAddress);
    setLocation([+y, +x]);
    // setOpenModal(false);
    // setIsLoading(false);
  };

  useEffect(() => {
    temp(keyword);
  }, [keyword]);

  const closeModal = e => {
    if (e.target.id === 'background') {
      handleGetPositionClick();
    }
  };
  const handleGetPositionClick = () => {
    function showPosition(position) {
      setLocation([position.coords.latitude, position.coords.longitude]);
    }
    setLocation([]);
    setIsLoading(true);
    if (navigator.geolocation) {
      const temp = e => console.log(e);
      navigator.geolocation.getCurrentPosition(showPosition, temp, {});
    } else {
      alert(
        '위치 정보를 지원하지않는 브라우저입니다. 주소 검색을 이용해주세요 ㅠㅠ'
      );
      setIsLoading(false);
    }
  };
  return (
    <S.Container onClick={e => closeModal(e)} id='background'>
      <S.FormContainerWrapper>
        <S.FormContainer>
          <S.InfoContainer>
            <S.InfoIcon>
              <span role='img' aria-label='img'>
                🕵️
              </span>
            </S.InfoIcon>
            <S.InfoDescription>마스크를 찾아서!</S.InfoDescription>
          </S.InfoContainer>
          <S.GetNowPosition onClick={() => handleGetPositionClick()}>
            여기를 누르면
            <br />
            '현재 위치'에 가까운 마스크 재고를 찾아볼 수 있어요
          </S.GetNowPosition>
          <S.QueryInput
            type='text'
            onChange={handleKeywordChange}
            placeholder='이 곳을 누르면 주소로 찾아볼 수도 있습니다.'
          />
          {addressList ? (
            addressList.map((address, index) => {
              return (
                <S.QueryResult
                  key={index}
                  onClick={() => handleResultClick(address)}
                >
                  {address.roadAddr}
                </S.QueryResult>
              );
            })
          ) : (
            <FiveInfo />
          )}
        </S.FormContainer>
      </S.FormContainerWrapper>
    </S.Container>
  );
});

export default Modal;
